import {Injectable} from '@angular/core';

import {AngularFireAuth} from 'angularfire2/auth';
import {Http, Headers, RequestOptions} from '@angular/http';

import {Observable} from 'rxjs/Observable';
import {Subject} from 'rxjs/Subject';
import {apiUrl} from '../../config/api.config';
import {GlobalUser} from '../../interfaces/globaluser.interface';
import {GlobalUserService} from '../local/global-user.service';

@Injectable()
export class RestApiAuthService {
  baseUrl = (apiUrl);

  constructor(private http: Http,
              private afAuth: AngularFireAuth) {
  }


  /**
   * Get API TOKEN
   * @returns {Observable<any>}
   */
  private getToken() {
    return this.fromFirebaseAuthPromise(this.afAuth.auth.currentUser.getIdToken());
  }


  /**
   * Sign User in
   * @param email
   * @param password
   * @returns {Observable<Observable<any>>}
   */
  signinUser(email, password) {
    return this.apiSigninWithEmailPassword(email, password)
      .switchMap(res => this.signinWithCustomToken(res.customToken));
  }


  /**
   * Signin User to Firebase with customtoken provided by RestAPI
   * @param customtoken
   * @returns {Observable<any>}
   */
  signinWithCustomToken(customtoken): Observable<any> {
    return this.fromFirebaseAuthPromise(this.afAuth.auth.signInWithCustomToken(customtoken));
  }


  /**
   * Sign User in
   * @param email
   * @param password
   * @returns {Observable<Observable<any>>}
   */
  activateTenantUser(email, password) {
    return this.apiSigninWithEmailPassword(email, password)
      .map(res => {
        console.log(res);
        localStorage.setItem('property_id', res.property_id);
        localStorage.setItem('org_id', res.org_id);
        localStorage.setItem('uid', res.uid);
        return this.signinWithCustomToken(res.customToken);
      });
  }


  /**
   * Get Custom token from Rest API
   * @param email
   * @param password
   * @returns {Observable<any>}
   */
  private apiSigninWithEmailPassword(email, password): Observable<any> {
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');

    const options = new RequestOptions({headers: headers});
    const body = ({
      email: email,
      password: password,
    });
    return this.http
      .post(this.baseUrl + 'authorizeUser', body, options)
      .map(response => response.json());
  }

  /**
   * Convert Promise of Firebase to an Observable
   * @param promise
   * @returns {Observable<any>}
   */
  private fromFirebaseAuthPromise(promise): Observable<any> {

    const subject = new Subject<any>();

    promise
      .then(res => {
          subject.next(res);
          subject.complete();
        },
        err => {
          subject.error(err);
          subject.complete();
        }
      );
    return subject.asObservable();
  }


  /**
   * Update Password Firebase Auth User Object
   * @param uid
   * @param password
   * @returns {Observable<any>}
   */
  updateUserPassword(password): Observable<any> {
    const uid = localStorage.getItem('uid');
    return this.getToken()
      .switchMap(res => {

        const headers = new Headers();
        headers.append('Authorization', 'Bearer ' + res);
        headers.append('Content-Type', 'application/json');

        const options = new RequestOptions({headers: headers});
        const body = ({
          uid: uid,
          password: password,
        });
        return this.http
          .post(this.baseUrl + 'updateUserPassword', body, options)
          .map(response => response.json());
      });
  }


}



// WEBPACK FOOTER //
// C:/Clients/rent-hero/web-application/src/app/_shared/services/rest-api/auth.service.ts